import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useParams } from "react-router-dom";
import { LoadingPanel } from "../../../components/layout/Loading";
import { Typography } from "@progress/kendo-react-common";
import moment from "moment";
import { Button } from "@progress/kendo-react-buttons";
import { getCompanyWisePendingPaymentReport } from "../services/reports.services";
import { checkAcessRights } from "../../../_helper/helper";
import { EXCEL_EXPORT_ACCESS, PRINT_ACCESS } from "../../../_contstants/common";

const CompanyWisePendingPaymentReportView = () => {
  const gridRef = React.useRef<any>(null);
  const dispatch = useAppDispatch();
  const params = useParams();
  const isExcelExportAccess = checkAcessRights(
    "/companywisependingpaymentreportform",
    EXCEL_EXPORT_ACCESS
  );
  const isPrintAccess = checkAcessRights(
    "/companywisependingpaymentreportform",
    PRINT_ACCESS
  );

  const CompanyID = params?.CompanyID;
  const DateType = params?.DateType;
  const Type = params?.Type;
  const TourID = params?.TourID;
  const FromDate = params?.FromDate;
  const ToDate = params?.ToDate;
  const loading = useAppSelector((state) => state.reports.loading);
  const CompanyWisePendingPaymentReport = useAppSelector(
    (state) => state.reports.CompanyWisePendingPaymentReport
  );

  useEffect(() => {
    if (CompanyID && FromDate && ToDate && DateType && Type) {
      const payload = {
        CompanyID: CompanyID ? CompanyID : null,
        FromDate: FromDate ? FromDate : "",
        ToDate: ToDate ? ToDate : "",
        DateType: DateType ? DateType : null,
        Type: Type ? Type : null,
        TourID: TourID !== "0" ? TourID : null,
      };
      dispatch(getCompanyWisePendingPaymentReport(payload));
    }
  }, []);

  let totalPassengers = 0;
  let totalRooms = 0;
  let totalCost = 0;
  let totalPaidCost = 0;
  let totalRemainingCost = 0;
  let totalNights = 0;
  CompanyWisePendingPaymentReport &&
    CompanyWisePendingPaymentReport.length > 0 &&
    CompanyWisePendingPaymentReport?.forEach((report: any) => {
      totalPassengers += report.TotalNoOfPax || 0;
      totalRooms += +report.TotalNoOfRooms || 0;
      totalCost += report.TourCost || 0;
      totalPaidCost += report.PaidAmount || 0;
      totalRemainingCost += report.RemainingAmount || 0;
      totalNights += +report.NoOfNights || 0
    });

  const handleExportExcel = () => {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.table_to_sheet(
      document.querySelector(".table-bordered")
    );
    XLSX.utils.book_append_sheet(wb, ws, "CompanyWisePendingPaymentReport");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(data, "companywisependingpaymentreport.xlsx");
  };

  const printTable = () => {
    let table = document.querySelector(
      ".table-bordered"
    ) as HTMLTableElement | null;
    let printbuttons = document.querySelector(".printbuttons") as any;
    let report_container = document.querySelector(".report-container") as any;
    if (!table) {
      console.error("Table element not found.");
      return;
    }

    printbuttons.style.display = "none";
    report_container.style.padding = "20px 0";
    let tableRows = table.rows.length;
    let maxRows = table.rows.length;
    let pageCount = Math.ceil(tableRows / maxRows);
    let printContent = document.createElement("div");
    let content = "";

    for (let i = 0; i < pageCount; i++) {
      content += '<div class="print-page">';
      //   content += "<h2>Page " + (i + 1) + "</h2>";
      content += '<table class="table table-bordered reportScreens">';

      let startRow = i * maxRows;
      let endRow = Math.min((i + 1) * maxRows, tableRows);

      for (let j = startRow; j < endRow; j++) {
        content += table.rows[j].outerHTML;
      }

      content += "</table>";
      content += "</div>";
    }

    printContent.innerHTML = content;
    table.style.display = "none";
    document.body.appendChild(printContent);

    const style = document.createElement("style");
    style.textContent = `@page { margin: 1cm; }`;
    document.head.appendChild(style);

    window.print();
    printContent.remove();
    table.style.display = "table";
    printbuttons.style.display = "block";
    report_container.style.padding = "20px 10px";
  };

  if (loading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      <div
        className="report-container"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px 10px",
        }}
      >
        <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
          Company Wise Pending Payment Report{" "}
          <span style={{ fontSize: 15 }}>
            (
            {FromDate
              ? moment(FromDate, "YYYY-MM-DD").format("DD/MM/YYYY")
              : ""}
            {" to "}
            {ToDate ? moment(ToDate, "YYYY-MM-DD").format("DD/MM/YYYY") : ""})
          </span>
        </Typography.h4>
        <div className="printbuttons">
          {isPrintAccess && (
            <Button
              style={{ marginRight: 5 }}
              type="button"
              fillMode={"solid"}
              themeColor={"primary"}
              onClick={printTable}
            >
              Print
            </Button>
          )}
          {isExcelExportAccess && (
            <Button
              type="button"
              fillMode={"solid"}
              themeColor={"primary"}
              onClick={handleExportExcel}
            >
              Excel Export
            </Button>
          )}
        </div>
      </div>
      <div className="table-responsive" style={{ margin: "0 10px" }}>
        <table className="table table-bordered reportScreens">
          <thead>
            <tr>
              <th style={{ background: "black", color: "white"}}>No</th>
              <th style={{ background: "black", color: "white" }}>Tour Date</th>
              <th style={{ background: "black", color: "white" }}>
                Tour Booking No
              </th>
              <th style={{ background: "black", color: "white" }}>Name</th>
              <th style={{ background: "black", color: "white" }}>Mobile No</th>
              <th style={{ background: "black", color: "white" }}>
                No. Of Passenger
              </th>
              <th style={{ background: "black", color: "white" }}>
                No. Of Room
              </th>
              <th style={{ background: "black", color: "white" }}>
                No. Of Nights
              </th>
              <th style={{ background: "black", color: "white" }}>
                Tour Date Code
              </th>
              <th style={{ background: "black", color: "white" }}>Tour Cost</th>
              <th style={{ background: "black", color: "white" }}>Paid Cost</th>
              <th style={{ background: "black", color: "white" }}>
                Remaining Cost
              </th>
            </tr>
          </thead>
          <tbody>
            {CompanyWisePendingPaymentReport &&
              CompanyWisePendingPaymentReport.length > 0 &&
              CompanyWisePendingPaymentReport?.map(
                (company: any, index: number) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>
                      {
                        company?.TourDate
                        ? moment(company?.TourDate, "DD/MM/YYYY").format(
                            "DD MMM YYYY"
                          )
                        : ""
                      }
                    </td>
                    <td>{company?.TourBookingNo}</td>
                    <td>{company?.Name}</td>
                    <td>{company?.MobileNo}</td>
                    <td>{company?.TotalNoOfPax}</td>
                    <td>{company?.TotalNoOfRooms}</td>
                    <td>{company?.NoOfNights || 0}</td>
                    <td>{company?.TourDateCode}</td>
                    <td>{company?.TourCost || 0}</td>
                    <td>{company?.PaidAmount || 0}</td>
                    <td>{company?.RemainingAmount || 0}</td>
                  </tr>
                )
              )}
            <tr className="fw-bold">
              <td
                colSpan={5}
                className="text-end pe-5"
                style={{ background: "lightgray", color: "black" }}
              >
                Total
              </td>
              <td style={{ background: "lightgray", color: "black" }}>
                {totalPassengers}
              </td>
              <td style={{ background: "lightgray", color: "black" }}>
                {totalRooms}
              </td>
              <td style={{ background: "lightgray", color: "black" }}>{totalNights}</td>
              <td style={{ background: "lightgray", color: "black" }}></td>
              <td style={{ background: "lightgray", color: "black" }}>
                {totalCost}
              </td>
              <td style={{ background: "lightgray", color: "black" }}>
                {totalPaidCost}
              </td>
              <td style={{ background: "lightgray", color: "black" }}>
                {totalRemainingCost}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default CompanyWisePendingPaymentReportView;
